module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper dashboard-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box palette-Pink-300 bg"
  }, [_c('div', {
    staticClass: "box-header  palette-Pink-300 bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "circle-nest-medium ti-user"
  })]), _vm._v("    ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   NEW USER")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "events-nest "
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('bars', {
    attrs: {
      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 0],
      "gradient": ['#ffffff', '#ffffff']
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "text-white"
  }, [_c('strong', [_c('animate-number', {
    attrs: {
      "from": "1",
      "to": "45",
      "duration": "9000",
      "easing": "easeOutQuad",
      "formatter": _vm.formatter
    }
  })], 1)]), _vm._v(" "), _c('span', [_vm._v("Active Users")]), _vm._v(" "), _c('p', [_vm._v("65%")]), _vm._v(" "), _c('br')], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box palette-Cyan-400 bg"
  }, [_c('div', {
    staticClass: "box-header  palette-Cyan-400 bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "circle-nest-medium ti-stats-up"
  })]), _vm._v("    ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   PAGE VIEWS")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "events-nest "
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('bars', {
    attrs: {
      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 0],
      "gradient": ['#ffffff', '#ffffff']
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "text-white"
  }, [_c('strong', [_c('animate-number', {
    attrs: {
      "from": "45575",
      "to": "744",
      "duration": "9000",
      "easing": "easeOutQuad",
      "formatter": _vm.formatter
    }
  })], 1)]), _vm._v(" "), _c('span', [_vm._v("PerWeek Views")]), _vm._v(" "), _c('p', [_vm._v("65%")]), _vm._v(" "), _c('br')], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box palette-Deep-Purple-300 bg"
  }, [_c('div', {
    staticClass: "box-header  palette-Deep-Purple-300 bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "circle-nest-medium dripicons-wallet"
  })]), _vm._v("    ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   DAILY SALES")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "events-nest "
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('bars', {
    attrs: {
      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 0],
      "gradient": ['#ffffff', '#ffffff']
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "text-white"
  }, [_c('strong', [_c('animate-number', {
    attrs: {
      "from": "0",
      "to": "13",
      "duration": "9000",
      "easing": "easeOutQuad",
      "formatter": _vm.formatter
    }
  })], 1)]), _vm._v(" "), _c('span', [_vm._v("Sales")]), _vm._v(" "), _c('p', [_vm._v("15%")]), _vm._v(" "), _c('br')], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "box palette-Indigo-900 bg"
  }, [_c('div', {
    staticClass: "box-header  palette-Indigo-900 bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "circle-nest-medium dripicons-basket"
  })]), _vm._v("    ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   TOTAL EARNINGS")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "events-nest "
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('bars', {
    attrs: {
      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 0],
      "gradient": ['#ffffff', '#ffffff']
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "text-white"
  }, [_c('strong', [_c('animate-number', {
    attrs: {
      "from": "1",
      "to": "3500",
      "duration": "9000",
      "easing": "easeOutQuad",
      "formatter": _vm.formatter
    }
  })], 1)]), _vm._v(" "), _c('span', [_vm._v("Dollars")]), _vm._v(" "), _c('p', [_c('animate-number', {
    attrs: {
      "from": "1",
      "to": "65",
      "duration": "9000",
      "easing": "easeOutQuad",
      "formatter": _vm.formatter
    }
  }), _vm._v("%")], 1), _vm._v(" "), _c('br')], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box no-shadow"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "text-white lastest-post-nest palette-Blue-800 bg"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('small', {
    staticClass: "palette-Blue-400 bg"
  }, [_c('i', {
    staticClass: "ti-facebook "
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('h1', {
    staticClass: "text-white"
  }, [_c('img', {
    staticClass: "img-circle palette-Grey-900 bg",
    attrs: {
      "alt": "profile",
      "src": "http://api.randomuser.me/portraits/thumb/men/46.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('h3', [_vm._v("D'Agustino Gavin")]), _vm._v(" "), _c('p', [_vm._v("Pink and Blue: Coloring Inside the Lines of Gender")]), _vm._v(" "), _c('p', [_c('el-rate', {
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('b', [_c('i', {
    staticClass: "ti-eye"
  }), _vm._v(" 121")]), _vm._v(" "), _c('b', [_c('i', {
    staticClass: "ti-thumb-up"
  }), _vm._v("45")]), _vm._v(" "), _c('b', [_c('i', {
    staticClass: "ti-comment-alt"
  }), _vm._v(" 8")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box no-shadow"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "text-white lastest-post-nest-two palette-Deep-Purple-500 bg"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('small', {
    staticClass: "palette-Blue-800 bg"
  }, [_c('i', {
    staticClass: "ti-twitter-alt "
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('h1', {
    staticClass: "text-white"
  }, [_c('img', {
    staticClass: "img-circle palette-Grey-900 bg",
    attrs: {
      "alt": "profile",
      "src": "http://api.randomuser.me/portraits/thumb/women/26.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('h3', [_vm._v("Dewi Saraswati")]), _vm._v(" "), _c('p', [_vm._v("Pink and Blue: Coloring Inside the Lines of Gender")]), _vm._v(" "), _c('p', [_c('el-rate', {
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('b', [_c('i', {
    staticClass: "ti-eye"
  }), _vm._v(" 121")]), _vm._v(" "), _c('b', [_c('i', {
    staticClass: "ti-thumb-up"
  }), _vm._v("45")]), _vm._v(" "), _c('b', [_c('i', {
    staticClass: "ti-comment-alt"
  }), _vm._v(" 8")])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-no-shadow"
  }, [_c('div', {
    staticClass: "box-body ",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "row summary-border-top",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "summary-nest"
  }, [_c('h2', {
    staticClass: "text-black "
  }, [_c('span', {
    staticClass: "counter-up"
  }, [_vm._v("276.747")]), _c('small', {
    staticClass: "palette-Orange-700 bg"
  }, [_vm._v("K")])]), _vm._v(" "), _c('p', [_vm._v("Sales")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 summary-border-left"
  }, [_c('div', {
    staticClass: "summary-nest"
  }, [_c('h2', {
    staticClass: "text-black"
  }, [_c('span', {
    staticClass: "counter-up"
  }, [_vm._v("3.219")]), _c('small', {
    staticClass: "palette-Pink-500 bg"
  }, [_vm._v("K")])]), _vm._v(" "), _c('p', [_vm._v("Man")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "summary-nest summary-pad-nest"
  }, [_c('bars', {
    attrs: {
      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 4],
      "gradient": ['#3b5998', '#3b5998']
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "counter-up"
  }, [_vm._v("5")]), _vm._v("/"), _c('span', {
    staticClass: "counter-up"
  }, [_vm._v("12")]), _vm._v("/"), _c('span', {
    staticClass: "counter-up"
  }, [_vm._v("2013")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row summary-border-bottom",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "summary-nest summary-pad-nest"
  }, [_c('h2', {
    staticClass: "text-black "
  }, [_c('span', {
    staticClass: "counter-up"
  }, [_vm._v("82")]), _c('small', {
    staticClass: "palette-Lime-500 bg "
  }, [_vm._v("%")])]), _vm._v(" "), _c('p', [_vm._v("Avarage Sales")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 summary-border-left"
  }, [_c('div', {
    staticClass: "summary-nest summary-pad-nest"
  }, [_c('h2', {
    staticClass: "text-black"
  }, [_c('span', {
    staticClass: "counter-up"
  }, [_vm._v("24")]), _c('small', {
    staticClass: "palette-Teal-500 bg "
  }, [_vm._v("th")])]), _vm._v(" "), _c('p', [_vm._v("Overall Rank")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-no-shadow bg-widget-random"
  }, [_c('div', {
    staticClass: "box-header bg-transparent"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "text-white ti-rss-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-white "
  }, [_vm._v("LASTEST REPORT")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "margin": "15px 0 0"
    }
  }, [_c('div', {
    staticClass: "stats-wrap"
  }, [_c('h2', [_c('b', {
    staticClass: "counter-up text-white"
  }, [_vm._v("65,800,587")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "background": "#666"
    }
  }, [_vm._v("+"), _c('b', {
    staticClass: "counter-up"
  }, [_vm._v("20")]), _vm._v("%")])]), _vm._v(" "), _c('p', {
    staticClass: "text-grey"
  }, [_vm._v("Total students"), _c('small', [_vm._v("This Year")])]), _vm._v(" "), _c('h4', [_c('b', {
    staticClass: "counter-up text-white"
  }, [_vm._v("1,204")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "background": "#888"
    }
  }, [_vm._v("+"), _c('b', {
    staticClass: "counter-up"
  }, [_vm._v("5")]), _vm._v("%")])]), _vm._v(" "), _c('p', [_vm._v("Graduate "), _c('small', [_vm._v("This week")])]), _vm._v(" "), _c('h4', {
    staticClass: "text-white"
  }, [_c('b', {
    staticClass: "counter-up"
  }, [_vm._v("2,690")]), _vm._v(" "), _c('span', [_vm._v("+"), _c('b', {
    staticClass: "counter-up"
  }, [_vm._v("125")])])]), _vm._v(" "), _c('p', [_vm._v("New students"), _c('small', [_vm._v("This Month")])]), _vm._v(" "), _c('div', {
    staticClass: "your-account"
  }, [_c('h4', [_vm._v("Overall stats of sales and distribution")]), _vm._v(" "), _c('h6', [_vm._v("You must "), _c('strong', [_vm._v("complete")]), _vm._v(" this issues.")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
    staticClass: "text-white palette-Orange-700 bg ti-pie-chart"
  }), _vm._v(" 2.789")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "text-white palette-Pink-700 bg ti-stats-down"
  }), _vm._v("4.365")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "palette-Cyan-700 bg text-white ti-bar-chart"
  }), _vm._v("9.860 ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7bfbeb4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dashboard/Index.vue
// module id = 1024
// module chunks = 2